package songwritersnotebook.app.utils

object ChordTransposer {
    private val NOTES_SHARP = listOf("C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B")
    private val NOTES_FLAT = listOf("C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B")

    fun transposeChordName(chordName: String, semitones: Int): String {
        if (chordName.isBlank()) return chordName
        
        // Find the root part (e.g., "F#" in "F#maj7/G")
        val rootRegex = """^([A-G][#b]?)""".toRegex()
        val match = rootRegex.find(chordName) ?: return chordName
        val root = match.groupValues[1]
        val rest = chordName.substring(root.length)

        val transposedRoot = transposeNote(root, semitones)
        
        // Handle slash chords (e.g., C/G)
        return if (rest.contains("/")) {
            val parts = rest.split("/", limit = 2)
            val beforeSlash = parts[0]
            val bassNote = parts[1]
            val transposedBass = transposeNote(bassNote, semitones)
            "$transposedRoot$beforeSlash/$transposedBass"
        } else {
            "$transposedRoot$rest"
        }
    }

    fun transposeLyrics(text: String, semitones: Int): String {
        val chordRegex = """\[([^\]]+)\]""".toRegex()
        return chordRegex.replace(text) { match ->
            val chordName = match.groupValues[1]
            "[" + transposeChordName(chordName, semitones) + "]"
        }
    }

    private fun transposeNote(note: String, semitones: Int): String {
        var index = NOTES_SHARP.indexOf(note)
        if (index == -1) index = NOTES_FLAT.indexOf(note)
        if (index == -1) return note // Fallback

        val newIndex = (index + semitones).let { 
            val mod = it % 12
            if (mod < 0) mod + 12 else mod
        }
        
        // ALWAYS use flats for consistency with library definitions
        return NOTES_FLAT[newIndex]
    }

    fun transposeGuitarTab(tab: List<String>?, semitones: Int): List<String>? {
        if (tab == null || semitones == 0) return tab
        
        return tab.map { fret ->
            if (fret.lowercase() == "x") "x"
            else {
                val currentFret = fret.toIntOrNull() ?: return@map fret
                // Shift fret and ensure it doesn't go below 0
                (currentFret + semitones).coerceAtLeast(0).toString()
            }
        }
    }
}
